export default __webpack_public_path__ + "static/media/skill_2.81d7fb14.png";